// Dependencies imports
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";
import Modal from "@mui/material/Modal";
//import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Paper from "@mui/material/Paper";
import { API } from "aws-amplify";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Local imports
import { Constants } from "../../../config/Constants";
import SendNotification from "./SendNotification";
import config from "../../../config/aws-exports";
import { awsSignIn, authData } from "../../../redux/auth/authSlice";

// Style imports
import Eng from "./Engage.module.scss";
//import { Box } from "@mui/material";

// Custom Toolbard to export and filter for datagrid
function CustomToolbar() {
  return (
    <GridToolbarContainer
      style={{ display: "flex", justifyContent: "flex-end" }}
    >
      <GridToolbar />
    </GridToolbarContainer>
  );
}

// Start of main Engage Component
export default function Engage() {
  //const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [tenantsnotify, setTenantsnotify] = useState({});
  const [rows, setRows] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [spin, setSpin] = useState(false);
  const [tenantslist, setTenantsList] = useState([]);
  const [singleUser] = useState(false);
  let userDetails = useSelector(authData);
  const [tenantname, setTenantName] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Useeffect for api call
  useEffect(() => {
    getTenants();
    return () => {};
  }, []);

  // function to get Tenants list
  async function getTenants() {
    setSpin(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const ten = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_TENANTS,
        bodyParam,
      );
      setTenantsList(ten.body);
      if (ten !== undefined && ten !== null) {
        const tenants = ten.body;
        let trows = [];
        for (let i = 0; i < tenants.length; i++) {
          let obj = {};
          obj.id = i;
          obj.tenant = tenants[i].did;
          trows.push(obj);
        }
        setRows(trows);
        setSpin(false);
      }
    } catch (error) {
      console.error(error);
      setSpin(false);
    }
  }

  const tcolumns = [
    {
      field: "tenant",
      headerName: "Organization Name",
      flex: 1,
      headerClassName: `${Eng.superHeader}`,
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCellClick = (param, event) => {
    console.log("row data on click", tenantslist[param.row.id].oid);

    if (param.field === "__check__") {
      return;
    }
    let sdata = { ...userDetails };
    sdata.BOID = tenantslist[param.row.id].oid;
    if (sdata.breadcrumb === undefined) {
      sdata.breadcrumb = [];
      let temp = [...sdata.breadcrumb];
      temp[0] = {
        name: "Engage",
        path: "/engage",
      };
      temp[1] = {
        name: param.row.tenant,
        path: "/engage/userengagement",
      };
      sdata.breadcrumb = temp;
    } else {
      let temp = [...sdata.breadcrumb];
      temp[0] = {
        name: "Engage",
        path: "/engage",
      };
      temp[1] = {
        name: param.row.tenant,
        path: "/engage/userengagement",
      };
      sdata.breadcrumb = temp;
    }

    dispatch(awsSignIn(sdata));

    navigate("/engage/userengagement");
    // console.log(event);
  };
  function checking(index1) {
    let rowObj = {};
    let rowObjName = {};
    let tenantlist = [];
    let tenentname = [];

    console.log("batch", index1);
    for (let i = 0; i < index1.length; i++) {
      rowObj = tenantslist[index1[i]].st_id;
      rowObjName = tenantslist[index1[i]].oid;
      tenantlist.push(rowObj);
      tenentname.push(rowObjName);
    }

    console.log("batch1", tenantlist);
    setTenantName(tenentname);
    setTenantsnotify(tenantlist);
  }
  // Start of main return
  return (
    <div className={Eng.main}>
      <Backdrop className={Eng.backdrop} open={spin}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={Eng.modal}
        open={open}
        // closeAfterTransition
        //BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={open}>
           <Box sx={{ p: 2 }}> */}
        <SendNotification
          handleClose={handleClose}
          tenantsnotify={tenantsnotify}
          userList={false}
          singleUser={singleUser}
          tenantname={tenantname}
        />
        {/* </Box>
        </Fade> */}
      </Modal>
      <div className={Eng.topbar}>
        {/* <h2 className={Eng.heading}>Engage</h2> */}
        {selectionModel !== undefined && selectionModel.length !== 0 ? (
          <button className={Eng.send} onClick={() => handleOpen()}>
            Send Notification
          </button>
        ) : null}
      </div>
      <Paper>
        <div style={{ height: 600, width: "100%", overflowY: "auto" }}>
          {/* <DataGrid
            rows={rows}
            columns={tcolumns}
            className={Eng.headerCell}
            slots={{
              toolbar: CustomToolbar,
            }}
            checkboxSelection
            disableSelectionOnClick
            onRowSelected={(e) => console.log(e)}
            onSelectionModelChange={(newSelection) => {
              console.log("j", newSelection);
              setSelectionModel(newSelection);
              checking(newSelection);
            }}
            selectionModel={selectionModel}
            onCellClick={handleCellClick}
          /> */}

          <DataGrid
            rows={rows}
            columns={tcolumns}
            className={Eng.headerCell}
            slots={{
              toolbar: CustomToolbar,
            }}
            checkboxSelection
            onRowSelectionModelChange={(newSelection) => {
              setSelectionModel(newSelection);
              checking(newSelection);
            }}
            selectionModel={selectionModel}
            onCellClick={handleCellClick}
          />
        </div>
      </Paper>
    </div>
  );
}
